<!--
일괄기능 컨트롤러에 사용되는
- 검색결과 전체작업 mixin
- 선택항목 작업 기능도 같이 제공함.
------------------------------------

-->

<script>
    import {urlToDown} from "../../../funcs/url-to-down";

    export default {
        props: {
            // 기본 조회 url (선택작업에 사용)
            basedUrl: {
                type: String,
                default: null
            },

            // 검색 url (검색결과 전체작업에 사용)
            searchedUrl: {
                type: String,
                default: null
            },

            // 검색결과 수
            searchedCount: {
                type: Number,
                default: null
            },
        },
        data: function () {

            return {
                // (int) 검색결과 다운로드 제한수
                searchedDownLimit: 2000,

                // (vue dom) 오버레이 컴포넌트
                overlay: null,
            };
        },
        methods: {

            /**
             * 선택된 항목없음 검증
             * @return bool
             */
            guardNoSelected() {
                if (this.itemCheckedCount && this.itemCheckedCount < 1) {
                    alert('선택된 항목이 없습니다.');
                    return false;
                }
                return true;
            },

            /**
             * 검색결과 다운로드 수량 제한 검증
             * @return bool
             */
            guardSearchedDownLimit() {
                // 다운로드 제한 수
                if (this.searchedCount > this.searchedDownLimit) {
                    alert('검색결과가 너무 많습니다(최대 : ' + this.searchedDownLimit + '건). 다른 검색옵션을 추가하세요');
                    return false;
                }
                return true;
            },

            /**
             * 다운처리
             * @param {URL|string} url 다운로드 url
             * @param {Object} fetch_opts fetch 옵션
             * @param {array<function|string>} guards 사전체크(검증 등..)작업이 정의된 함수배열
             *      e.g. [
             *          () => {return true}, // boolean 반환하는 함수
             *          () => {return false},
             *          "정말 실행하겠습니까?", // (string) 인경우, 컨펌으로 처리
             *      ]
             *
             * @return {Promise<Blob>}
             */
            download(url, fetch_opts, guards) {
                // 사전작업
                let guard_passed = true;
                _.find(guards, (guard) => {
                    if (typeof guard === 'string') {
                        //컨펌 처리
                        const confirm_msg = guard;
                        guard = () => {
                            return confirm(confirm_msg);
                        }

                    } else if (typeof guard !== 'function') {
                        return;

                    }
                    //console.log(guard, guard());
                    // 호출
                    if (! guard()) {
                        guard_passed = false;
                        return true;
                    }

                });
                if (! guard_passed) {
                    return Promise.reject();
                }





                // url 문자열인경우
                if (typeof url === 'string') {
                    url = new URL(url);
                }

                // 화면 block
                this.overlay = this.$refs['down-overlay'];
                if (this.overlay) {
                    this.overlay.overlayOn();
                }

                // 다운로드
                return urlToDown(url, fetch_opts)
                    .then((blob) => {

                    })
                    .catch((e) => {
                        alert(e.message);
                    })
                    .finally(() => {
                        // 오버레이 종료
                        if (this.overlay) {
                            this.overlay.overlayOff();
                        }
                    });

            },

            /**
             * 새창열기
             *
             * @param {HTMLElement} form FORM 엘리먼트
             * @param {FormData} data 파라메터
             * @param {array<function|string>} guards 사전체크(검증 등..)작업이 정의된 함수배열
             *      e.g. [
             *          () => {return true}, // boolean 반환하는 함수
             *          () => {return false},
             *          "정말 실행하겠습니까?", // (string) 인경우, 컨펌으로 처리
             *      ]
             *
             * @return {Promise}
             */
            openWindow(form, data, guards) {
                // 사전작업
                let guard_passed = true;
                _.find(guards, (guard) => {
                    if (typeof guard === 'string') {
                        //컨펌 처리
                        const confirm_msg = guard;
                        guard = () => {
                            return confirm(confirm_msg);
                        }

                    } else if (typeof guard !== 'function') {
                        return;

                    }
                    //console.log(guard, guard());
                    // 호출
                    if (! guard()) {
                        guard_passed = false;
                        return true;
                    }

                });
                if (! guard_passed) {
                    return Promise.reject();
                }

                // 파라메터
                if (data) {
                    let input = null;
                    data.forEach((value, key) => {
                        input = document.createElement("input");
                        input.type = 'hidden';
                        input.name = key;
                        input.value = value;
                        form.appendChild(input);
                    });
                }

                // 윈도우 이름
                let window_name = form.target;
                if (! window_name) {
                    window_name = Date.now();
                    form.target = window_name;
                }

                // 새창 열기
                window.open('', window_name);

                // submit
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);

                return Promise.resolve();

            },

        },
    }
</script>